import axios from "axios";
import { Config } from "../Config";

export const fetchPracticeInformations = async (practiceData) => {

  if (!practiceData?.practice_name) {
    return { error: "Practice name is required" };
  }

  try {
    const response = axios.get(
      `${Config?._AppAPIServer}/search-practice?practice_name=${practiceData?.practice_name}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const storeAppointment = async (formData) => {
  try {
    const response = await axios.post(
      `${Config._AppAPIServer}/book-appointment/create`,formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};